import styled from 'styled-components';

import {Card as BaseCard, Button as BaseButton} from '@mui/material';

export const Card = styled(BaseCard)`
  padding: 20%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10%;
  background: ${(props) => props.theme.colorBackground} !important;
`;

export const Img = styled.div`
  img {
    width: 100%;
    height: auto;
  }
`;

export const Text = styled.p`
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const Button = styled(BaseButton)`
  padding: 20px 100px !important;
  background: ${(props) => props.theme.colorAccent} !important;

  @media (max-width: 768px) {
    padding: 10px 30px !important;
  }
`;
